<template>
  <div
      class="order-return-select-items flex flex-auto flex-col">
    <div>
      <div class="title">
        Select items you want to return
      </div>
      <div class="description">
        Please select the items you would like to proceed with and add a return reason.
      </div>
    </div>
    <el-card
        class="select-all-card"
        :class="{'highlighted-select-all-card' : allSelected}">
      <div
          class="select-all-text flex-auto">
        Select all
      </div>
      <AllReturnReasons
          v-if="allSelected"
          :return-reasons="returnReasons"
          @selected-all-reason="setSelectedAllReason" />
      <el-checkbox
          v-model="allSelected"
          @change="selectAll" />
    </el-card>
    <ReturnableOrderItemView
        v-for="item in selections"
        :key="item.id"
        :is-selected="item.selected"
        :selected-reason="item.reason"
        :selected.sync="item.selected"
        :reason.sync="item.reason"
        :return-reasons="returnReasons"
        :all-selected="allSelected"
        v-bind="item"
        @uncheckSelectAll="uncheckSelectAll" />
  </div>
</template>


<script>
import AllReturnReasons from "./AllReturnReasons.vue";
import ReturnableOrderItemView from "./ReturnableOrderItemView.vue";
import { cloneDeep } from "lodash";

export default {
  name: "ReturnSelectItems",
  components: { ReturnableOrderItemView, AllReturnReasons },
  props: {
    returnReasons: {
      type: Array,
      default() {
        return [];
      },
    },
    returnableItems: {
      type: Array,
      default() {
        return [];
      },
    },
    alreadySelected: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selections: [],
      allSelected: false,
    };
  },
  watch: {
    selections: {
      handler: function (value) {
        this.$emit("get-selected-items-for-return", value);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.alreadySelected.length > 0) {
      this.selections = this.alreadySelected;
    } else {
      let selections = cloneDeep(this.returnableItems);
      for (const key in selections) {
        selections[key].selected = false;
        selections[key].reason = null;
      }
      this.selections = selections;
    }
  },
  methods: {
    setSelectedAllReason(reason_id) {
      for (const item of this.selections) {
        item.reason = reason_id;
      }
    },
    selectAll(value) {
      for (const item of this.selections) {
        item.selected = value;
      }
      this.setSelectedAllReason(null);
    },
    uncheckSelectAll() {
      this.allSelected = false;
    },
  },
};
</script>

<style>
.order-return-select-items {
  gap: 8px;

  .title {
    width: 532px;
    height: 36px;
    font-family: "Equip";
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
  }

  .description {
    width: 532px;
    height: 48px;
    font-family: "Equip";
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
    word-break: break-word;
  }
  .select-all-card {
    box-shadow: none !important;
    box-sizing: border-box;
    align-items: center;
    padding: 16px 24px;
    height: 80px !important;
    margin-top: 15px;
  }
  .highlighted-select-all-card {
    background: #eff8fc;
    border: 2px solid #1998d5;
    border-radius: 4px;
  }
  .select-all-card {
    .select-all-text {
      height: 24px;
      font-family: "Equip";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #424242;
      padding: 12px 0px 12px 0px;
    }
  }
  .el-card {
    margin-bottom: 0 !important;
    .el-card__body {
      margin: 0 !important;
      display: flex;
      flex-direction: row;
    }
  }
}
.order-return-select-items {
  .el-checkbox {
    align-items: center;
    display: flex;
    margin-left: 16px;
  }
  .el-checkbox__inner {
    width: 24px;
    height: 24px;
    border: 1px solid #81919f;
  }
  .el-checkbox__inner::after {
    width: 3.94px;
    height: 9.2px;
    top: 5px;
    left: 8px;
  }
}
</style>
